// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__74i2W","title":"Info_title__1lmuo","links":"Info_links__tF7Bc","link":"Info_link__1D7OY","logo":"Info_logo__FjUqU"};